import * as React from 'react';
import { Select } from '@app/src/components/Select';
import { Field } from '@app/src/components/Field';

export const RenderSelect = ({
  options,
  label,
  placeholder,
  portionWidth,
  meta: { error, touched },
  input
}) => {
  const isError = (error && touched) ? error : '';
  const { value, ...otherProps } = input;
  return(
    <Field label={label} portionWidth={portionWidth} errorMessage={isError}>
      <Select
        selected={value}
        placeholder={placeholder}
        uncontrolled
        {...otherProps}
        error={!!isError}
        options={options}
      />
    </Field>
  );
}
